import React, { useEffect } from 'react';
// components
import Book from '../BookItem';
// hooks
import { useBestSellerFetch } from '../Hooks/useBestSellerFetch';
import { useUserBooksFetch } from '../Hooks/useUserBooksFetch';
// react-bootstrap
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Spinner from 'react-bootstrap/Spinner';

// helper
import { markBestSellerBooksAsFavourite } from '../../utils/helpers';

const BestSellerPage = () => {
  const { bestSellerState, loading, error } = useBestSellerFetch();
  const { userBooksState } = useUserBooksFetch();

  const hardcover = bestSellerState.books_list.filter(
    (book) => book.best_seller_list === 'hardcover'
  );
  const manga = bestSellerState.books_list.filter(
    (book) => book.best_seller_list === 'manga'
  );
  const science = bestSellerState.books_list.filter(
    (book) => book.best_seller_list === 'science'
  );

  useEffect(() => {
    if (userBooksState.total_results > 0) markBestSellerBooksAsFavourite();
  }, [userBooksState]);

  return (
    <Container className={'py-5 px-5'}>
      <h1 className='text-center'>NY TIMES Best Seller</h1>
      {loading && (
        <div className={'my-5 text-center'}>
          <Spinner
            animation='border'
            variant='primary'
            className={'text-center'}
          />
        </div>
      )}
      <Row>
        <h2 className='mt-5 ms-2' style={{ color: 'var(--brandSecondary)' }}>
          Hardcover Fiction
        </h2>
        {hardcover.map((book) => (
          <Col
            xs={6}
            md={4}
            lg={2}
            className={'text-center p-3'}
            key={book._id}
          >
            <Book book={book} source={'best-seller'} />
          </Col>
        ))}
      </Row>
      <Row>
        <h2 className='mt-4 ms-2' style={{ color: 'var(--brandSecondary)' }}>
          Manga
        </h2>
        {manga.map((book) => (
          <Col
            xs={6}
            md={4}
            lg={2}
            className={'text-center p-3'}
            key={book._id}
          >
            <Book book={book} source={'best-seller'} />
          </Col>
        ))}
      </Row>
      <Row>
        <h2 className='mt-4 ms-2' style={{ color: 'var(--brandSecondary)' }}>
          Science
        </h2>
        {science.map((book) => (
          <Col
            xs={6}
            md={4}
            lg={2}
            className={'text-center p-3'}
            key={book._id}
          >
            <Book book={book} source={'best-seller'} />
          </Col>
        ))}
      </Row>
    </Container>
  );
};

export default BestSellerPage;
